import { Button } from 'primereact/button';
import React from 'react';
import { defineMessages, FormattedMessage, useIntl } from 'react-intl';

const messages = defineMessages({
  updateDetails: {
    id: 'actions.update_details',
    defaultMessage: 'Update details',
  },
  edit: {
    id: 'actions.edit',
    defaultMessage: 'Edit',
  },
  changePassword: {
    id: 'actions.change_password',
    defaultMessage: 'Change password',
  },
});

const UserDetailsHeader = ({
  user,
  userIsViewingOwnPage,
  toggleUpdateDetails,
  toggleChangePassword,
  handleDeletingUser,
}) => {
  const { formatMessage } = useIntl();

  return (
    <div className="p-grid p-nogutter">
      <div className="p-col">{`${user.firstName} ${user.lastName}`}</div>
      {userIsViewingOwnPage && (
        <div className="p-grid">
          <div className="p-col-4">
            <Button
              tooltip={formatMessage(messages.updateDetails)}
              icon="fa fa-pencil"
              type="button"
              className="p-button-secondary p-button-sm"
              onClick={() => toggleUpdateDetails(true)}
            />
          </div>
          <div className="p-col-4">
            <Button
              tooltip={formatMessage(messages.changePassword)}
              icon="fa fa-lock"
              type="button"
              className="p-button-secondary p-button-sm"
              onClick={() => toggleChangePassword(true)}
            />
          </div>
          <div className="p-col-4">
            <FormattedMessage id="user.delete-button-label" defaultMessage="Delete account">
              {(text) => (
                <Button
                  tooltip={text}
                  icon="fa fa-trash"
                  className="p-button-danger"
                  onClick={handleDeletingUser}
                />
              )}
            </FormattedMessage>
          </div>
        </div>
      )}
    </div>
  );
};

export default UserDetailsHeader;
